import React, { Component } from 'react';
import { User } from '../../services/user';
import config from '../../services/config';

import './login.css';

const ErrorMessage = ({ errorMessage }) => {
  return (
    <div className="alert alert-danger">{errorMessage}</div>
  );
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      showError: false
    };
    this.loginInputChange = this.loginInputChange.bind(this);
    this.login = this.login.bind(this);
  }

  loginInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  async login(event) {
    event.preventDefault();
    let user = await User.login(this.state.username, this.state.password);
    console.log(user)
    if (user.loggedIn) {
      this.props.history.push({
        pathname: config.defaultPage,
        state: { user: user }
      })
    } else {
      this.setState({showError: true});
    }
  }

  render() {
    return (
      <div className="container login-container">
        <div className="row">
          <div className="col-md-5">
              <div className="login-logo">
                <img src={process.env.PUBLIC_URL + '/logo/modfin_medium_logo_blue.png'} alt="Modfin"/>
              </div>
            <div className="login-panel">
              <div className="login-error">
                { this.state.showError ? <ErrorMessage errorMessage="You have entered an invalid email address or password"/> : null }
              </div>
              <div className="panel panel-default">
                <div className="panel-body">
                  <form onSubmit={this.login}>
                    <fieldset>
                      <div className="form-group">
                        <input className="form-control" placeholder="Username" name="username" type="text" autoFocus={true}
                             value={this.state.username} onChange={this.loginInputChange} />
                      </div>
                      <div className="form-group">
                        <input className="form-control" placeholder="Password" name="password" type="password"
                             value={this.state.password} onChange={this.loginInputChange} />
                      </div>
                      <button className="btn btn-lg btn-primary btn-block" type="submit">Login</button>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-7 rightHalf">
          </div>
        </div>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/containers/Login/index.js